var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMachineGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D71B8",
    d: "M133.5 30h-75c-4.142 0-7.5 2.686-7.5 6v120c0 3.314 3.358 6 7.5 6h75c4.142 0 7.5-2.686 7.5-6V36c0-3.314-3.358-6-7.5-6Z",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: "M115 54H77m38 24H77m56.5-48h-75c-4.142 0-7.5 2.686-7.5 6v120c0 3.314 3.358 6 7.5 6h75c4.142 0 7.5-2.686 7.5-6V36c0-3.314-3.358-6-7.5-6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D71B8",
    d: "M96 144a9 9 0 0 0 9-9 9 9 0 0 0-9-9 9 9 0 0 0-9 9 9 9 0 0 0 9 9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: "M24.25 82.125h-7.5m7.5 12.5h-7.5M33 63H7.182C5.425 63 4 64.811 4 67.046v80.909C4 150.189 5.425 152 7.182 152H33"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D71B8",
    d: "M21 143a4.688 4.688 0 1 0 0-9.376A4.688 4.688 0 0 0 21 143Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: "M167.75 82.125h7.5m-7.5 12.5h7.5M159 63h25.818c1.757 0 3.182 1.811 3.182 4.046v80.909c0 2.234-1.425 4.045-3.182 4.045H159"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D71B8",
    d: "M171 143a4.688 4.688 0 1 1 0-9.376 4.688 4.688 0 0 1 0 9.376Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachineGroup);
export default __webpack_public_path__ + "static/media/MachineGroup.8b07dc5b9fd4f796e80d574ac6d31f29.svg";
export { ForwardRef as ReactComponent };